import { useInjectReducer } from 'redux-injectors';
import { useActions } from 'common/hooks';
import { actions, reducer, sliceKey } from '../slice';

export const useCatalogueContentSlice = () => {
	useInjectReducer({ key: sliceKey, reducer });
	return useActions(actions);
};
